import { render, staticRenderFns } from "./cancelled.vue?vue&type=template&id=6086642b"
import script from "./cancelled.vue?vue&type=script&lang=js"
export * from "./cancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports